import React from "react";
import { Row, Col, List, Space,Avatar } from "antd";
import SearchBar from '../component/SearchBar'

const data = [
    {
        key: 1,
        text: '南方，寂寞鐵道：我們在時光列車上相遇',
    },
    {
        key: 2,
        text: '貓主子的科學：喵皇賣萌大小事',
    },
    {
        key: 3,
        text: '電玩遊戲進化史【圖解漫畫版】：從桌遊、RPG、任天堂到VR，回味玩心設計大躍進的魅力指南',
    },
    {
        key: 4,
        text: '快速開飯的5分鐘預漬備料魔法：只要學會就能10分鐘快速上桌，92道讓你天天省時輕鬆煮的美味提案！',
    },
    {
        key: 5,
        text: "艾爾登法環：官方美術設定集（第一集）Elden Ring: Official Art Book Volume I",
    },
];

const SearchPage = ({
    label_language
}) => {
    return (<>
        <Row gutter={[0, 20]} justify={'center'}>
            <Col span={24}>
                <Row
                    justify={'center'}
                    align="middle"
                    style={{ backgroundColor: 'lightblue', height: '30vh' }}
                >
                    <Col lg={{ span: 12 }} xs={{ span: 20 }}>
                        <SearchBar label_language={label_language.children.Search} />
                    </Col>
                </Row>
            </Col>
            <Col lg={{ span: 12 }} xs={{ span: 20 }}>
                <List
                    bordered
                    itemLayout="horizontal"
                    dataSource={data}
                    renderItem={(item, index) => (
                        <List.Item>
                            <List.Item.Meta
                                avatar={<Avatar src={`https://xsgames.co/randomusers/avatar.php?g=pixel&key=${index}`} />}
                                title={<a style={{ textDecorationLine:"none" }} href="https://ant.design">{item.text}</a>}
                            />
                        </List.Item>
                    )}
                />
            </Col>
        </Row>

    </>)
}

export default SearchPage